import { jsx as _jsx } from "react/jsx-runtime";
import Plot from "react-plotly.js";
export const BarChart = ({ autosize, config, data, layout, sliders, style }) => {
    return (_jsx(Plot, { autosize: autosize, config: config, data: data, layout: layout, sliders: sliders, style: style, useResizeHandler: true }));
};
